const initialState = {
  notificationDisplay: false,
  enableAnalyticsCookies: false,
  notificationDeclined: null
};

export default initialState;
